import HTTP from '@/utils/http'
import notification from '@/utils/notification'

export async function createQuery (bidId) {
  return HTTP.post('/queries', { bidId })
}

export async function updateQuery (id, query, showNotification = true) {
  const response = await HTTP.put(`/queries/${id}`, query)
  if (showNotification) {
    notification.handleResponseAlert(response)
  }
}

export async function updateQueryStatus (id, status, showNotification = true) {
  const response = await HTTP.patch(`/queries/${id}`, { status })
  if (showNotification) {
    notification.handleResponseAlert(response)
  }
}

export async function removeQuery (id) {
  const response = await HTTP.delete(`/queries/${id}`)
  return response.data.data
}

export async function checkQueryEditable (queryId, userInfo) {
  try {
    const response = await HTTP.get(`/queries/${queryId}/check-editable`, {params: userInfo})
    return response.data || {}
  } catch (err) {
    notification.handleResponseAlert(err.response)
    return null
  }
}

export async function keepQueryEdit (bidId, userInfo) {
  try {
    const response = await HTTP.silentPut(`/queries/${bidId}/keep-edit`, userInfo)
    return response.data || {}
  } catch (err) {
    notification.handleResponseAlert(err.response)
    return null
  }
}
